import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import CenterDataForm from './form/CenterDataForm.tsx'
import useInputs from '../../../utils/hooks/useInputs.js'
import CenterService from '../../../services/centers/center.service.js'
import swalAlert from '../../../utils/helpers/swalAlert.js'
import { urlBack } from './utils/center.utils.ts'
import CenterSection from './common/CenterSection.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterData = () => {
  const { formatMessage: msg } = useIntl()

  const { id } = useParams()
  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        updateInputs(response.resp)
      }
    }
  }

  const handleSave = async () => {
    const data = {
      ...inputs,
      basicData: {
        ...inputs?.basicData,
        activityType:
          inputs?.basicData?.activityType?._id ||
          inputs?.basicData?.activityType,
        company: inputs?.basicData?.company?._id || inputs?.basicData?.company,
        zoneLeader:
          inputs?.basicData?.zoneLeader?._id || inputs?.basicData?.zoneLeader,
      },
    }

    const response =
      id && id !== 'undefined'
        ? await CenterService.update({ id: inputs?._id, body: data })
        : await CenterService.create(data)
    if (response) {
      updateInputs(response?.resp)
      navigate(urlBack(inputs?.centerType))
    }
  }

  const handleRemove = async () => {
    const confirm = await swalAlert.warning(
      msg({ id: 'button.delete' }),
      msg({ id: 'button.cancel' }),
      msg({ id: 'button.delete' }),
    )
    if (confirm?.isConfirmed) {
      const response = await CenterService.remove(inputs?._id)
      if (response) {
        navigate(urlBack(inputs?.centerType))
      }
    }
  }

  const headerOptions = {
    title: inputs?.basicData?.name,
    handlerHeaderActions: {
      showBackButton: true,
      backButton: () => navigate(urlBack(inputs?.centerType)),

      primaryButton: () => handleRemove(),
      primaryButtonText: 'button.delete',
      primaryButtonIcon: 'pi-trash',

      secondaryButton: () => handleSave(),
      secondaryButtonText: 'button.save',
      secondaryButtonIcon: 'pi-save',
    },
  }

  const data = (
    <CenterDataForm
      centerId={id}
      handleSave={handleSave}
      inputs={inputs}
      onChangeInputs={onChangeInputs}
      updateInputs={updateInputs}
    />
  )

  return (
    <CenterSection
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(inputs?.centerType))}
            />,
            <AppButton preset="remove" onClick={handleRemove} />,
            <AppButton preset="save" onClick={handleSave} />,
          ]}
        />
      }
    >
      {data}
    </CenterSection>
  )
}

export default CenterData
